import { component } from 'picoapp'
import Drift from 'drift-zoom'

let drift
let activeIndex = 0

export default component(({ node: el }) => {
  const pieces = el.querySelectorAll('.js-image-single')
  const mainImage = el.querySelector('.js-main-image')
  const mainCaption = el.querySelector('.js-caption')
  const canvas = el.querySelector('.js-canvas')
  if (pieces) {
    pieces.forEach((single, i) => {
      const imageSrc = single.getAttribute('data-swap')
      const imageZoom = single.getAttribute('data-zoom')
      const imageCaption = single.getAttribute('data-caption')
      single.addEventListener('click', () => {
        mainImage.src = imageSrc
        activeIndex = i
        mainImage.setAttribute('data-zoom', imageZoom)
        mainCaption.innerHTML = imageCaption
        // drift = new Drift(mainImage, {
        //   paneContainer: canvas,
        //   inlinePane: false,
        //   containInline: true,
        //   handleTouch: false,
        //   touchBoundingBox: true,
        //   zoomFactor: 2,
        //   hoverBoundingBox: false
        // })
      })
    })
  }

  function go (index) {
    const imageSrc = pieces[index].getAttribute('data-swap')
    const imageZoom = pieces[index].getAttribute('data-zoom')
    const imageCaption = pieces[index].getAttribute('data-caption')
    mainImage.src = imageSrc
    activeIndex = index
    mainImage.setAttribute('data-zoom', imageZoom)
    mainCaption.innerHTML = imageCaption
    // drift = new Drift(mainImage, {
    //   paneContainer: canvas,
    //   inlinePane: false,
    //   containInline: true,
    //   handleTouch: false,
    //   touchBoundingBox: true,
    //   zoomFactor: 2,
    //   hoverBoundingBox: false
    // })
  }

  function slide (direction) {
    switch (direction) {
      case 'left':
        if (activeIndex === 0) {
          go(pieces.length - 1)
        } else {
          go(activeIndex - 1)
        }
        break
      case 'right':
        if (activeIndex === pieces.length - 1) {
          go(0)
        } else {
          go(activeIndex + 1)
        }
    }
  }

  if (pieces.length > 1) {
    const leftSwitch = el.querySelector('.js-controls-left')
    const rightSwitch = el.querySelector('.js-controls-right')

    leftSwitch.classList.remove('hidden')
    rightSwitch.classList.remove('hidden')

    leftSwitch.addEventListener('click', () => {
      slide('left')
    })
    rightSwitch.addEventListener('click', () => {
      slide('right')
    })
  }

  // drift = new Drift(mainImage, {
  //   paneContainer: canvas,
  //   inlinePane: false,
  //   containInline: true,
  //   handleTouch: true,
  //   touchBoundingBox: true,
  //   zoomFactor: 2,
  //   hoverBoundingBox: false
  // })

  mainImage.addEventListener('click', () => {
    canvas.classList.toggle('zoom')
    // debugger;
  })
})
